import Navbar from '../../components/Navbar';
import PageWithAsyncData from '../../components/PageWithAsyncData';
import { useParams } from 'react-router-dom';
import {
  useGetCompany,
  useGetCompanyOfficeHours,
} from '../../hooks/use-hydra/admin';
import CompanyPageWrapper from '../../components/Admin/CompanyPageWrapper';
import { COMPANY_PAGES } from '../../components/Admin/CompanySideNavigation';
import SubcohortOfficeHour from '../../components/Admin/SubcohortOfficeHour';
import dayjs from 'dayjs';
import { ROUTES } from '../../routing';

export default function SubcohortOfficeHourPage() {
  const { id, officeHourId } =
    useParams<{ id: string; officeHourId: string }>();
  const {
    data,
    isLoading: isCompanyLoading,
    error,
    refetch,
  } = useGetCompany(parseInt(id));

  const { data: officeHoursData } = useGetCompanyOfficeHours(parseInt(id));

  const officeHourGroup = officeHoursData?.officeHoursGroups.find((oh) =>
    oh.officeHours.find(
      (oh) => oh.officeHourId === parseInt(officeHourId ?? '0')
    )
  );
  const officeHour = officeHourGroup?.officeHours.find(
    (oh) => oh.officeHourId === parseInt(officeHourId ?? '0')
  );
  const officeHourTimestamp = officeHour?.timestamp;
  const cohortStartDate = officeHourGroup?.cohort.startDate;
  const weekNumber =
    Math.floor(
      dayjs.utc(officeHourTimestamp).diff(cohortStartDate, 'day') / 7
    ) + 1;

  const localTimezone = dayjs.tz.guess();

  const breadcrumbLabel = officeHour
    ? `Week ${weekNumber} Call - ${dayjs
        .utc(officeHourTimestamp)
        .tz(localTimezone)
        .format('D MMM YYYY HH:mm')}`
    : 'Office Hour';

  return (
    <PageWithAsyncData
      isLoading={isCompanyLoading}
      error={error}
      retry={refetch}
      noScroll
    >
      <Navbar
        breadCrumbs={[
          {
            label: 'Home',
            url: ROUTES.HOME.getPath(),
          },
          {
            label: 'Teams',
            url: ROUTES.ADMIN.COMPANIES.getPath(),
          },
          {
            label: data?.name || 'Company',
            url: ROUTES.ADMIN.COMPANY.getPath({ companyId: id }),
          },
          {
            label: 'Office Hours',
            url: ROUTES.ADMIN.OFFICE_HOURS.getPath({ companyId: id }),
          },
          {
            label: breadcrumbLabel,
            url: null,
          },
        ]}
      />
      <CompanyPageWrapper
        currentPage={COMPANY_PAGES.OFFICE_HOURS}
        scrollStyle={{ overflow: 'hidden' }}
        contentStyle={{ padding: 0 }}
        shouldAddEmptyDiv={false}
      >
        <SubcohortOfficeHour />
      </CompanyPageWrapper>
    </PageWithAsyncData>
  );
}
